// extracted by mini-css-extract-plugin
export var cost = "style-module--cost--39dfb";
export var cost__desc = "style-module--cost__desc--ccf6b";
export var cost__inner = "style-module--cost__inner--50168";
export var cost__item = "style-module--cost__item--72422";
export var cost__itemList = "style-module--cost__item--list--4463e";
export var cost__newcost = "style-module--cost__newcost--d5b87";
export var cost__subtitle = "style-module--cost__subtitle--d8a0b";
export var cost__title = "style-module--cost__title--aae22";
export var cost__widget = "style-module--cost__widget--4a97c";
export var cost__wrapper = "style-module--cost__wrapper--de891";